let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hck5E")).then(() => parcelRequire('gArBD'));